/**
 * ReturnRequestDialog için sabit değerler
 */

// Varsayılan değerler
export const DEFAULT_LANGUAGE_ID = 2;
export const DEFAULT_PAGE_SIZE = 500;
export const DEFAULT_QUANTITY = 1;
export const INVOICE_NO_MAX_LENGTH = 50;

// Parça arama ayarları
export const MIN_SEARCH_LENGTH = 3;
export const SEARCH_PAGE_SIZE = 1000;

// Dosya yükleme ayarları
export const FILE_UPLOAD_CONFIG = {
    maxFileSize: 20971520, // 20MB
    acceptedFileTypes: {
        'image/*': ['.png', '.jpg', '.jpeg', '.gif'],
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
        'application/vnd.ms-excel': ['.xls'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
        'text/plain': ['.txt']
    }
};

// İlk form state değerleri
export const INITIAL_FORM_STATE = {
    partCode: '',
    uom: '',
    selectedReasonType: null,
    quantity: DEFAULT_QUANTITY,
    returnDescription: '',
    lineDescription: '',
    invoiceNo: '',
    isFaultyPart: false,
    chassisNo: '',
    assemblyKm: null,
    faultKm: null,
    assemblyDate: null,
    faultDate: null
};

// Validasyon field isimleri
export const VALIDATION_FIELDS = {
    PART: 'part',
    SELECTED_REASON_TYPE: 'selectedReasonType',
    QUANTITY: 'quantity',
    INVOICE_NO: 'invoiceNo',
    CHASSIS_NO: 'chassisNo',
    ASSEMBLY_KM: 'assemblyKm',
    FAULT_KM: 'faultKm',
    ASSEMBLY_DATE: 'assemblyDate',
    FAULT_DATE: 'faultDate'
};
